export enum RecipeViewType {
  All = 0,
  Unlinked = 1,
  Linked = 2,
  Unnecessary = 3,
}

export enum RecipeType {
  Standard = 0,
  SubRecipe = 1,
  IsHidden = 2,
  IsPrivate = 3,
}

export enum ingredientUnitOfMeasure {
  Teaspoon = 0,
  Tablespoon = 1,
  Fluidounce = 2,
  Cup = 3,
  Pint = 4,
  Quart = 5,
  Gallon = 6,
  Ounce = 7,
  Pound = 8,
  Each = 9,
}

export enum ingredientAssignesToCategory {
  All = 0,
  Dairy = 1,
  DryGroceries = 2,
  Freezer = 3,
  Fruits = 4,
  Grains = 5,
  Meat = 6,
  Seafood = 7,
  Spices = 8,
  Sweets = 9,
  Vegetable = 10,
}

export enum IngredientInfoActionType {
  Edit,
  Delete,
}

export interface IngredientInfoCardMenuOption {
  id: IngredientInfoActionType;
  icon: string;
  tooltipTitle: string;
}

export enum UnitOfMeasure {
  Teaspoon = 0,
  Fluidounce = 1,
  Cup = 2,
  Pint = 3,
  Quart = 4,
  Gallon = 5,
  Ounce = 6,
  Pound = 7,
  Each = 8,
  Milliliter = 9,
  Liter = 10,
  Gram = 11,
  Kilogram = 12,
  Milligram = 13,
}
